var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 2.375,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 4.5,
    fill: "url(#paint0_radial_1456_112595)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg_2",
    x: 2.375,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 4.5,
    fill: "url(#paint1_radial_1456_112595)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bg_3",
    x: 2.375,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 4.5,
    fill: "url(#paint2_radial_1456_112595)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "instagram_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.125 7.875C18.125 8.49632 17.6213 9 17 9C16.3787 9 15.875 8.49632 15.875 7.875C15.875 7.25368 16.3787 6.75 17 6.75C17.6213 6.75 18.125 7.25368 18.125 7.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 15.75C14.9461 15.75 16.625 14.0711 16.625 12C16.625 9.92893 14.9461 8.25 12.875 8.25C10.8039 8.25 9.125 9.92893 9.125 12C9.125 14.0711 10.8039 15.75 12.875 15.75ZM12.875 14.25C14.1176 14.25 15.125 13.2426 15.125 12C15.125 10.7574 14.1176 9.75 12.875 9.75C11.6324 9.75 10.625 10.7574 10.625 12C10.625 13.2426 11.6324 14.25 12.875 14.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.375 11.7C5.375 9.17976 5.375 7.91965 5.86547 6.95704C6.2969 6.11031 6.98531 5.4219 7.83204 4.99047C8.79465 4.5 10.0548 4.5 12.575 4.5H13.175C15.6952 4.5 16.9554 4.5 17.918 4.99047C18.7647 5.4219 19.4531 6.11031 19.8845 6.95704C20.375 7.91965 20.375 9.17976 20.375 11.7V12.3C20.375 14.8202 20.375 16.0804 19.8845 17.043C19.4531 17.8897 18.7647 18.5781 17.918 19.0095C16.9554 19.5 15.6952 19.5 13.175 19.5H12.575C10.0548 19.5 8.79465 19.5 7.83204 19.0095C6.98531 18.5781 6.2969 17.8897 5.86547 17.043C5.375 16.0804 5.375 14.8202 5.375 12.3V11.7ZM12.575 6H13.175C14.4599 6 15.3333 6.00117 16.0084 6.05633C16.6661 6.11006 17.0024 6.20745 17.237 6.32698C17.8015 6.6146 18.2604 7.07354 18.548 7.63803C18.6676 7.87263 18.7649 8.20893 18.8187 8.86656C18.8738 9.54169 18.875 10.4151 18.875 11.7V12.3C18.875 13.5849 18.8738 14.4583 18.8187 15.1334C18.7649 15.7911 18.6676 16.1274 18.548 16.362C18.2604 16.9265 17.8015 17.3854 17.237 17.673C17.0024 17.7926 16.6661 17.8899 16.0084 17.9437C15.3333 17.9988 14.4599 18 13.175 18H12.575C11.2901 18 10.4167 17.9988 9.74156 17.9437C9.08393 17.8899 8.74763 17.7926 8.51303 17.673C7.94854 17.3854 7.4896 16.9265 7.20198 16.362C7.08245 16.1274 6.98506 15.7911 6.93133 15.1334C6.87617 14.4583 6.875 13.5849 6.875 12.3V11.7C6.875 10.4151 6.87617 9.54169 6.93133 8.86656C6.98506 8.20893 7.08245 7.87263 7.20198 7.63803C7.4896 7.07354 7.94854 6.6146 8.51303 6.32698C8.74763 6.20745 9.08393 6.11006 9.74156 6.05633C10.4167 6.00117 11.2901 6 12.575 6Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1456_112595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.875 17.25) rotate(-55.3758) scale(19.1397)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1456_112595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.125 23.25) rotate(-65.1363) scale(16.9457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1456_112595",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.25 2.25) rotate(-8.1301) scale(29.1682 6.23877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColored);
export default __webpack_public_path__ + "static/media/instagram-colored.e2ca3163d54fcd5830b2861b9c4b52cf.svg";
export { ForwardRef as ReactComponent };